<template>
  <!--dialog pin-->
  <v-container>
    <v-dialog :persistent="PersistentDialog" v-model="DialogPin" max-width="600px" @keypress="isNumber()" @keyup.enter="sendPin(pin)">
      <v-card>
        <v-overlay :value="loaderOverlay" :absolute="true">
          <v-row justify="center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-row>
        </v-overlay>
        <v-card-text>
          <v-row align="center" justify="center" class="pa-4 pb-0">
            <div :class="'ma-0 pa-0 unselectable ' + CssFontTime" :style="{ color: +$vuetify.theme.dark ? 'white' : '' }">
              {{ timeText }}
            </div>
          </v-row>
          <v-row align="center" justify="center">
            <div :class="'unselectable ' + CssFontSize" :style="{ color: +$vuetify.theme.dark ? 'white' : '' }">
              {{ dateText }}
            </div>
          </v-row>
          <v-row align="center" justify="center" class="pa-4 pb-0">
            <v-text-field
              ref="ppass"
              :label="enterPinText"
              :color="$vuetify.theme.dark ? 'white' : 'primary'"
              :append-icon="pinPass ? 'mdi-eye' : 'mdi-eye-off'"
              v-model="pin"
              :type="pinPass ? 'text' : 'password'"
              @click:append="pinPass = !pinPass"
              @keypress="isNumber()"
              @keyup.enter="sendPin(pin)"
              class="styled-input centered-input"
              readonly
              autofocus
              required
            ></v-text-field>
          </v-row>
          <v-row justify="center">
            <v-col cols="4" v-for="x in 9" :key="x" v-tap="(e) => NumBtnClick(x)">
              <v-row justify="center" no-gutters>
                <v-btn
                  :small="sizeA"
                  :large="!sizeA"
                  fab
                  dark
                  :class="$vuetify.theme.dark ? 'white--text buttonFont' : 'grey--text buttonFont'"
                  :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'"
                  @keyup.enter="sendPin(pin)"
                  @keypress="$refs.ppass.focus()"
                  >{{ x }}</v-btn
                >
              </v-row>
            </v-col>
            <v-col cols="4" v-tap="(e) => (pin = '')">
              <v-row justify="center" no-gutters>
                <v-btn
                  :small="sizeA"
                  :large="!sizeA"
                  fab
                  dark
                  :class="$vuetify.theme.dark ? 'white--text' : 'grey--text'"
                  :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'"
                  @keyup.enter="sendPin(pin)"
                  @keypress="$refs.ppass.focus()"
                  >Clear</v-btn
                >
              </v-row>
            </v-col>
            <v-col cols="4" v-tap="(e) => NumBtnClick(0)">
              <v-row justify="center" no-gutters>
                <v-btn
                  :small="sizeA"
                  :large="!sizeA"
                  fab
                  dark
                  :class="$vuetify.theme.dark ? 'white--text buttonFont' : 'grey--text buttonFont'"
                  :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'"
                  @keypress="$refs.ppass.focus()"
                  >0</v-btn
                >
              </v-row>
            </v-col>

            <v-col cols="4">
              <v-row justify="center" v-tap="(e) => sendPin(pin)">
                <v-btn
                  v-if="btnEnter"
                  :small="sizeA"
                  :large="!sizeA"
                  fab
                  dark
                  :class="$vuetify.theme.dark ? 'white--text' : 'grey--text'"
                  @keyup.enter="sendPin(pin)"
                  @keypress="$refs.ppass.focus()"
                  >Enter</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ShowOTPLogin" max-width="600px">
      <v-card>
        <v-col>
          <OTPLogin
            @success="
              ShowOTPLogin = false;
              returnSuccess();
            "
            :LoginMode="true"
            :PIN="pin"
          />
        </v-col>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import OTPLogin from "../OTPLogin.vue";

export default {
  name: "PinPad",
  components: { OTPLogin },
  data: () => ({
    DialogPin: true,
    ShowOTPLogin: false,
    loaderOverlay: false,
    CssFontSize: ["body-2 "],
    CssFontTime: ["display-4"],
    sizeA: false,
    pinPass: false,
    btnEnter: false,
    pin: "",
    numpadKeys: [96, 97, 98, 99, 100, 101, 102, 103, 104, 105]
  }),
  computed: {
    enterPinText: function () {
      return this.$t("enterPin");
    }
  },
  watch: {
    ShowOTPLogin: function (val) {
      if (!val) {
        this.hideOTP();
      }
    },
    DialogPin: function (val) {
      this.DialogPin = val;
      if (this.DialogPin) {
        //this.$nextTick(() => this.$refs.ppass.focus());
      } else {
        this.pin = "";
        this.$emit("close");
        this.$destroy();
      }
    },
    pin: async function (val) {
      this.pin = val;
      if (this.pin.length == 4) {
        if (!this.btnEnter) await this.sendPin(this.pin);
      }
    }
  },
  props: {
    PersistentDialog: {
      type: Boolean,
      default: false
    },
    timeText: {
      type: String
    },
    dateText: {
      type: String
    }
  },
  created() {
    this.initialize();
  },
  beforeDestroy: function () {
    this.removeEvents();
  },
  methods: {
    initialize: function () {
      window.addEventListener("keyup", this.keyEvent);
    },
    removeEvents: function () {
      window.removeEventListener("keyup", this.keyEvent);
    },
    hideOTP: function () {
      this.ShowOTPLogin = false;
      window.addEventListener("keyup", this.keyEvent);
    },
    keyEvent(event) {
      if (this.numpadKeys.includes(event.keyCode)) {
        this.NumBtnClick(this.numpadKeys.indexOf(event.keyCode));
      } else if ((event.keyCode == 8 || event.keyCode == 46) && this.pin.length > 0 && this.pin.length <= 4) {
        this.pin = this.pin.substring(0, this.pin.length - 1);
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        if (this.pin.length >= 4) {
          evt.preventDefault();
        }

        return true;
      }
    },
    NumBtnClick(Num) {
      if (this.pin.length <= 3) {
        this.pin += Num;
      }
    },
    clearPin() {
      this.pin = "";
      this.$nextTick(() => this.$refs.ppass.focus());
    },
    async sendPin(PIN) {
      this.loaderOverlay = true;
      await this.$store
        .dispatch("user/loginPin", PIN)
        .then((resp) => {
          if (
            resp.data != undefined &&
            resp.data.data != undefined &&
            resp.data.data.requestOTPLogin != null &&
            resp.data.data.requestOTPLogin != undefined &&
            resp.data.data.requestOTPLogin
          ) {
            window.removeEventListener("keyup", this.keyEvent);
            this.ShowOTPLogin = true;
            this.loaderOverlay = false;
          } else {
            this.returnSuccess();
            this.loaderOverlay = false;
          }
        })
        .catch((err) => {
          this.loaderOverlay = false;
          this.pin = "";
          if (err.response.status != 200) {
            if (err.response.data.error) this.$eventHub.$emit("showError", this.$t(err.response.data.error), "bottom", "right");
            else {
              this.$eventHub.$emit("showError", this.$t("unexpectedError"), "bottom", "right");
            }
          }
        });
    },
    returnSuccess: function () {
      this.$emit("success");
      this.dialogPin = false;
    }
  }
};
</script>

<style></style>
